import { createAction } from '@reduxjs/toolkit';
import { CloseStatusPanelAction } from './types';

export const actions = {
  closeStatusPanel: createAction<CloseStatusPanelAction>(
    'gettingStarted/closeStatusPanel'
  ),
};
